export default function ({ store, redirect }) {
  if (store.$auth.$state.user.user_role !== 1) {
    return redirect("/dashboard");
  }
}
